import React from "react"
import { Grid, List } from "antd-mobile"
import { ToDate4, ToDate5, TradeLightColor, TradeLightValueColor } from "../factory/FactoryUtil";



export const CoinCellView = React.memo(({data, onUndo = () => {}}) => {

    const headerCss = {color : '#999', wordBreak : 'break-word'}
    const [name = '', symbol = ''] = (data.symbol || '').split('/')
    
    return (
        <List.Item className="cellCardBorder">
            <Grid columns={3} style={{fontSize : '14px', alignItems : 'center', '--gap-vertical' : '4px', '--gap-horizontal' : '2px'}}>

                <Grid.Item span={3} style={{marginBottom : '10px'}}>
                    <div style={{display : 'flex', alignItems : "center"}}>
                        <div style={{marginRight : '6px', fontWeight : 'bold', color : TradeLightValueColor(data.way, 1)}}>{data.way === 1 ? 'Buy' : 'Sell'}</div> 
                        <div style={{marginRight : '6px'}}>{data.symbol}</div> 
                        <div style={{flex : '1', fontSize : '12px', color : 'gray'}}>{ToDate5(data.creationDate)}</div>
                        <div onClick={onUndo} style={{background : '#6094FF', color : '#FFF', fontSize : '13px', padding : '6px 12px', borderRadius : '6px'}}>Undo</div>
                    </div>
                </Grid.Item>
            
                <Grid.Item style={headerCss}>Price({name})</Grid.Item>
                <Grid.Item style={headerCss}>Amount({symbol})</Grid.Item>
                <Grid.Item style={{...headerCss, textAlign : 'right'}}>Actual Trade({symbol})</Grid.Item>

                <Grid.Item style={{wordBreak : 'break-word'}}>{data.entrust_price}</Grid.Item>
                <Grid.Item style={{wordBreak : 'break-word'}}>{data.entrust_volume}</Grid.Item>
                <Grid.Item style={{wordBreak : 'break-word', textAlign : 'right'}}>0.00</Grid.Item>
            </Grid>
        </List.Item>
    )
})

export const FutureCellView = React.memo(({data = {}, buttonText = '', onDo = ()=>{}}) => {

    const headerCss = {color : '#999', wordBreak : 'break-word'}
    return (
        <List.Item className="cellCardBorder">
            <Grid columns={3} style={{fontSize : '14px', alignItems : 'center', '--gap-vertical' : '4px', '--gap-horizontal' : '2px'}}>

                <Grid.Item span={3} style={{marginBottom : '10px'}}>
                    <div style={{display : 'flex', alignItems : "center"}}>
                        <div style={{marginRight : '6px', fontWeight : 'bold', color : TradeLightValueColor(data.type, 0)}}>{data.type === 0 ? 'Buy' : 'Sell'}</div> 
                        <div style={{marginRight : '6px'}}>{data.symbol}</div> 
                        <div style={{flex : '1', fontSize : '12px', color : 'gray', wordBreak : 'break-word'}}>
                            Multiple({data.multiple}) x Hand({data.hands})
                        </div>
                        <div style={{color : TradeLightColor(data.profits)}}>{data.profits}</div>
                    </div>
                </Grid.Item>
                <Grid.Item style={headerCss}>Opening</Grid.Item>
                <Grid.Item style={headerCss}>Current price</Grid.Item>
                <Grid.Item style={{...headerCss, textAlign : 'right'}}>Amount</Grid.Item>

                <Grid.Item>{data.open_price}</Grid.Item>
                <Grid.Item>{data.market_price}</Grid.Item>
                <Grid.Item style={{textAlign: 'right'}}>{data.hands}</Grid.Item>

                <Grid.Item style={headerCss}>Handling free</Grid.Item>
                <Grid.Item style={headerCss}>Margin</Grid.Item>
                <Grid.Item style={{...headerCss, textAlign : 'right'}}>Available margin</Grid.Item>

                <Grid.Item>{data.poundage}</Grid.Item>
                <Grid.Item>{data.margin}</Grid.Item>
                <Grid.Item style={{textAlign: 'right'}}>{data.margin}</Grid.Item>

                <Grid.Item style={headerCss}>Open time</Grid.Item>
                <Grid.Item style={headerCss}>Delivery time</Grid.Item>
                <Grid.Item style={headerCss}></Grid.Item>

                <Grid.Item>{ToDate4(data.creationDate)}</Grid.Item>
                <Grid.Item>{ToDate4(data.deliveryDate)}</Grid.Item>
                {
                    buttonText.length > 0 ? (
                        <Grid.Item>
                            <div onClick={onDo} style={{background : '#6094FF', textAlign : 'center', color : '#FFF', fontSize : '13px', padding : '6px 12px', borderRadius : '6px'}}>{buttonText}</div>
                        </Grid.Item>
                    ) : ''
                }
            </Grid>
        </List.Item>
    )
})